<template>
  <fragment>
    <default-header :h2="$t('registerPassword.title')"></default-header>
    <back-btn></back-btn>
    <form @submit.prevent="submit" class="mb-4">
      <div class="innerContent noBottomPadding noSpaceBetween">
        <img class="login-tester" src="@/assets/ebt965p.png" alt="Exide EBT-965P" />

        <div class="form-group small-label p-2">
          <input
            type="password"
            v-model="createPassword"
            v-validate="'required|min:8'"
            :data-vv-as="$t('login.password')"
            name="register-password"
            id="register-password"
            class="form-control"
            :placeholder="$t('login.password')"
          />
          <label v-show="createPassword" for="register-password">{{$t('login.password')}}</label>
          <span
            class="small ml-3 mt-1 d-block text-center"
            :class="{'red' : errors.first('register-password')}"
          >{{$t('registerPassword.characters')}}</span>
          <button type="submit" class="btn btn-primary mt-3 mb-2 fw">{{$t('general.logIn')}}</button>
        </div>
      </div>
    </form>
  </fragment>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import DefaultHeader from '@/partials/DefaultHeader';
import BackBtn from '../components/BackBtn';

export default {
  name: 'Register',
  components: {
    DefaultHeader,
    BackBtn
  },
  data() {
    return {
      createPassword: ''
    };
  },
  computed: {
    ...mapGetters({
      countries: 'getCountries',
      registerData: 'getRegisterData',
      registerStatus: 'getRegisterStatus'
    })
  },
  methods: {
    ...mapActions(['getRegisterDataAction', 'createRegisterPasswordAction', 'setMessage']),
    submit() {
      this.languageError = this.currentLanguage == null;
      this.countryError = this.currentCountry == null;
      this.$validator.validate().then(valid => {
        if (valid) {
          this.createRegisterPasswordAction(this.createPassword);
        }
      });
    }
  },
  watch: {
    registerStatus(newVal) {
      this.setMessage(newVal);
      if (newVal.status === 'success') {
        this.$router.push({ name: 'Login' });
      }
    }
  }
};
</script>
